export default __webpack_public_path__ + "tmp_src/components/SiteFooter/SiteFooter~nova.css.liquid";